//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, { CancelToken } from "axios";

export default {
  components: {},

  data() {
    return {
      uid_procure: "",
      Showloading: false,
      bar2: false,
      vendor: "",
      date: "",
      chkduedate: "",
      location: {
        value: "",
        label: "ALL"
      },
      print_status: {
        value: "ALL",
        label: "ALL"
      },
      emb_status: {
        value: "ALL",
        label: "ALL"
      },
      locations: [
        {
          value: "",
          label: "ALL"
        },
        {
          value: "G1",
          label: "G1"
        },
        {
          value: "G2",
          label: "G2"
        },
        {
          value: "G3",
          label: "G3"
        },
        {
          value: "G4",
          label: "G4"
        },
        {
          value: "G5",
          label: "TRM"
        },
        {
          value: "G6",
          label: "VN"
        }
      ],
      status_list: [
        {
          value: "ALL",
          label: "ALL"
        },
        {
          value: "Over Due",
          label: "Over Due"
        },
        {
          value: "In Due",
          label: "In Due"
        }
      ],
      vendorlist: [],
      processDataEmbAll: [],
      processDataPrintAll: [],
      // processDataEmb: {
      //   value: 'ALL',
      //   label: 'ALL'
      // },
      processDataEmb: [],
      processDataPrint: [],
      filter_vender_print: {
        value: "ALL",
        label: "ALL"
      },
      filter_vendor_print_all: [],

      filter_vender_emb: {
        value: "ALL",
        label: "ALL"
      },
      filter_vendor_emb_all: [],

      print_so_list: [],
      print_so: "",
      emb_so_list: [],
      emb_so: "",

      thumbStyle: {
        right: "0px",
        borderRadius: "0px",
        backgroundColor: "#027be3",
        width: "10px",
        opacity: 0.75
      },

      barStyle: {
        right: "2px",
        borderRadius: "0px",
        backgroundColor: "#027be3",
        width: "10px",
        opacity: 0.2
      },

      // filter: {
      //   VENDOR_NAME: ''
      // },

      // filterEmb: {
      //   VENDOR_NAME: ''
      // },

      sumPrint: {
        order: 0,
        scanout: 0,
        scanin: 0,
        balance: 0,
        scanoutall: 0,
        scaninall: 0,
        pendingall: 0
      },
      sumEmb: {
        order: 0,
        scanout: 0,
        scanin: 0,
        balance: 0,
        scanoutall: 0,
        scaninall: 0,
        pendingall: 0
      },

      columns: [
        {
          name: "MOOD",
          label: "",
          field: "MOOD",
          sortable: true,
          align: "center"
        },
        {
          name: "VENDOR_SHORT_NAME",
          align: "left",
          label: "Vendor",
          field: "VENDOR_SHORT_NAME",
          sortable: true,
          style: {
            width: "10px"
          }
        },
        {
          name: "VENDOR_LT",
          label: "LT",
          field: "VENDOR_LT",
          sortable: true,
          style: {
            width: "10px"
          }
        },
        {
          name: "TARGET_DATE",
          label: "Due Date",
          field: "TARGET_DATE",
          align: "center",
          sortable: true,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
          // style: {
          //   width: '10px'
          // }
        },
        {
          name: "MC_LINE",
          label: "Line",
          field: "MC_LINE",
          sortable: true,
          align: "left"
        },
        {
          name: "FACTORY",
          align: "center",
          label: "Loc",
          field: "FACTORY",
          sortable: true
        },
        {
          name: "SO_NO_DOC",
          label: "SO",
          field: "SO_NO_DOC",
          sortable: true,
          align: "center"
        },
        {
          name: "SCAN_OUT",
          label: "Scan out",
          field: "SCAN_OUT",
          sortable: true,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
        },
        {
          name: "SCAN_IN",
          label: "Scan in",
          field: "SCAN_IN",
          sortable: true,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
        },

        {
          name: "PER_SCAN_IN",
          label: "%",
          field: "PER_SCAN_IN",
          sortable: true,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
        }
      ],

      pagination: {
        rowsPerPage: 0
      }
    };
  },
  created() {
    this.CheckLocal();
    this.LoadFirst();
  },
  async mounted() {
    this.uid_procure = this.$store.getters.uid;
  },
  watch: {
    location: function(newValue, oldValue) {
      this.LoadData();
    },
    date: function(newValue, oldValue) {
      this.LoadData();
    },
    print_so: function(newValue, oldValue) {
      this.LoadDataPrint();
    },
    emb_so: function(newValue, oldValue) {
      this.LoadDataEmb();
    },
    filter_vender_print: function(newValue, oldValue) {
      this.LoadDataPrint();
    },
    filter_vender_emb: function(newValue, oldValue) {
      this.LoadDataEmb();
    },
    print_status: function(newValue, oldValue) {
      this.LoadDataPrint();
    },
    emb_status: function(newValue, oldValue) {
      this.LoadDataEmb();
    }
  },
  methods: {
    LoadFirst() {
      this.pulling = setTimeout(() => {
        this.chkAuthen("", "");
        this.CurrDate();
        this.pullData();
        this.LoadData();
        this.getUserAccessData();
      }, 1000);
    },
    pullData() {
      this.pulling = setInterval(() => {
        var currentdate = new Date();
        if (
          currentdate.getMinutes() % 60 == 0 &&
          currentdate.getSeconds() == 0
        ) {
          this.LoadData();
        }
        // console.log(currentdate)
      }, 1000);
    },
    CurrDate() {
      console.log(this.$api);
      let params = new FormData();
      axios({
        method: "post",
        url: this.$api + "Page03.php/curdate",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.chkduedate = res.data.dte;
        this.date = res.data.dte
      });
    },

    getUserAccessData() {
      let params = new FormData();
      params.append("uid", this.$store.getters.uid);
      const obj = axios({
        method: "post",
        url: this.$api + "master.php/UserAccessData",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.UserAccessData = res.data;
      });

      return obj;
    },

    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    EditVendor(id, subprocess, fac) {
      if (this.uid_procure == "kaweewat.k" || this.uid_procure == "pranee.o") {
        this.bar2 = true;
        this.vendor = id;

        let params = new FormData();
        params.append("vendid", id);
        params.append("subprocess", subprocess);
        params.append("fac", fac);

        const obj = axios({
          method: "post",
          url: this.$api + "Page032.php/vendorlist",
          data: params
        }).then(res => {
          //   console.log(res.data);
          this.vendorlist = res.data.data;
        });
      }
    },
    async saveshort(id, val, fac) {
      let a = await this.saveshort2(id, val, fac);
    },

    interfaceData(fac) {
      const obj = axios({
        method: "get",
        url: `http://172.16.9.89:5000/ppr_subprocess_external/${fac}`
      }).then(res => {
        this.bar2 = false;
        this.LoadData();
      });
      return obj;
    },

    saveshort2(id, val, fac) {
      let params = new FormData();
      params.append("vid", id);
      params.append("short", val);
      let url = "";
      if (fac == "G6") {
        url = this.$api + "Page032.php/updShortVN";
      } else {
        url = this.$api + "Page032.php/updShort";
      }

      const obj = axios({
        method: "post",
        url: url,
        data: params
      }).then(res => {
        // console.log(res.data);
        if (res.data.success == 1) {
          this.interfaceData(fac);
        }
      });
      return obj;
    },

    savelt(id, val, step, fac) {
      // console.log(id + ' ' + val + ' '+step)
      let params = new FormData();
      params.append("vid", id);
      params.append("fac", fac);
      params.append("step", step);
      params.append("lt", val);

      // console.log(fac)
      const obj = axios({
        method: "post",
        url: this.$api + "Page032.php/updLT",
        data: params
      }).then(res => {
        // console.log(res.data);
        if (res.data.success == 1) {
          this.bar2 = false;
          this.LoadData();
        }
      });
    },

    async LoadData() {
      this.processDataEmbAll = [];
      this.processDataPrintAll = [];
      this.processDataEmb = [];
      this.processDataPrint = [];
      this.Showloading = true;

      const stepPrint = this.LoadDataPrint();
      const stepEmb = this.LoadDataEmb();

      let a = await stepPrint;
      let b = await stepEmb;

      this.Showloading = false;
    },
    LoadDataEmb() {
      let params = new FormData();
      // console.log(this.emb_so.substring(0, 8))
      // console.log(this.emb_so.substring(9))

      this.sumEmb.order = 0;
      this.sumEmb.scanout = 0;
      this.sumEmb.scanin = 0;
      this.sumEmb.balance = 0;
      this.sumEmb.scanoutall = 0;
      this.sumEmb.scaninall = 0;
      this.sumEmb.pendingall = 0;

      params.append("loc", this.location.value);
      params.append("dte", this.date);
      params.append("so", this.emb_so.substring(0, 8));
      params.append("soloc", this.emb_so.substring(9));
      params.append("vid", this.filter_vender_emb.value);
      params.append("duedate", this.chkduedate);
      params.append("status", this.emb_status.value);

      const obj = axios({
        method: "post",
        url: this.$api + "Page032.php/emb",
        data: params
      }).then(res => {
        // console.log(res.data)

        this.filter_vendor_emb_all = res.data.vendors;
        this.emb_so_list = res.data.sos;
        this.processDataEmb = res.data.datalist;

        this.sumEmb.order = res.data.so_qty;
        this.sumEmb.scanout = res.data.so_scan_out;
        this.sumEmb.scanin = res.data.so_scan_in;
        this.sumEmb.balance = res.data.so_balance;
        this.sumEmb.scanoutall = res.data.so_scan_out_all;
        this.sumEmb.scaninall = res.data.so_scan_in_all;
        this.sumEmb.pendingall = res.data.pendingall;
      });

      return obj;
    },
    LoadDataPrint() {
      let params = new FormData();

      this.sumPrint.order = 0;
      this.sumPrint.scanout = 0;
      this.sumPrint.scanin = 0;
      this.sumPrint.balance = 0;
      this.sumPrint.scanoutall = 0;
      this.sumPrint.scaninall = 0;
      this.sumPrint.pendingall = 0;

      params.append("loc", this.location.value);
      params.append("dte", this.date);
      params.append("so", this.print_so.substring(0, 8));
      params.append("soloc", this.print_so.substring(9));
      params.append("vid", this.filter_vender_print.value);
      params.append("duedate", this.chkduedate);
      params.append("status", this.print_status.value);

      const obj = axios({
        method: "post",
        url: this.$api + "Page032.php/print",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.filter_vendor_print_all = res.data.vendors;
        this.print_so_list = res.data.sos;
        this.processDataPrint = res.data.datalist;

        this.sumPrint.order = res.data.so_qty;
        this.sumPrint.scanout = res.data.so_scan_out;
        this.sumPrint.scanin = res.data.so_scan_in;
        this.sumPrint.balance = res.data.so_balance;
        this.sumPrint.scanoutall = res.data.so_scan_out_all;
        this.sumPrint.scaninall = res.data.so_scan_in_all;
        this.sumPrint.pendingall = res.data.pendingall;
      });

      return obj;
    },

    getClassSize() {
      if (this.$q.screen.width <= 1440) {
        return "fnt2";
      } else {
        return "fnt2";
      }
    },

    getClassSizecenter() {
      if (this.$q.screen.width <= 1440) {
        return "fnt2 text-center";
      } else {
        return "fnt2 text-center";
      }
    },

    getClassSizeright() {
      if (this.$q.screen.width <= 1440) {
        return "fnt2 text-right";
      } else {
        return "fnt2 text-right";
      }
    },

    create_UUID() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },

    exportExcel() {
      window.open(
        `${this.$apiflask}nyg_sub_external?uuid=${this.create_UUID()}`,
        // "http://qbi.nanyangtextile.com:8080/nyg_sub_external" +
        //   "?uuid=" +
        //   this.create_UUID(),
        "_export"
      );
      // window.open("http://127.0.0.1:8080/nyg_ppr_planship" + "?uuid=" + this.create_UUID(), "_export")
    }

    // filterDataPrint() {

    //   var filteredElements = {}
    //   let filter = this.filter
    //   for (var prop in filter) {
    //     if (filter[prop] != '' && filter[prop] != 'ALL') {
    //       // console.log(prop)
    //       filteredElements[prop] = filter[prop]
    //     }
    //   }

    //   if (this.isEmpty(filteredElements)) {
    //     this.processDataPrint = this.processDataPrintAll

    //   } else {

    //     var DataFilter = this.processDataPrintAll.filter(function (item) {
    //       for (var key in filteredElements) {
    //         if (item[key] === undefined || item[key] != filteredElements[key])
    //           return false;
    //       }
    //       return true;
    //     });

    //     // console.log(DataFilter)
    //     this.processDataPrint = DataFilter

    //   }

    // },

    // filterDataEmb() {

    //   var filteredElements = {}
    //   let filter = this.filterEmb
    //   for (var prop in filter) {
    //     if (filter[prop] != '' && filter[prop] != 'ALL') {
    //       // console.log(prop)
    //       filteredElements[prop] = filter[prop]
    //     }
    //   }

    //   if (this.isEmpty(filteredElements)) {
    //     this.processDataEmb = this.processDataEmbAll

    //   } else {

    //     var DataFilter = this.processDataEmbAll.filter(function (item) {
    //       for (var key in filteredElements) {
    //         if (item[key] === undefined || item[key] != filteredElements[key])
    //           return false;
    //       }
    //       return true;
    //     });

    //     // console.log(DataFilter)
    //     this.processDataEmb = DataFilter

    //   }

    // }
  }
};
